import { render, staticRenderFns } from "./SdsTableSection15Material.vue?vue&type=template&id=7baaf121&scoped=true"
import script from "./SdsTableSection15Material.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableSection15Material.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdsTableSection15Material.vue?vue&type=style&index=0&id=7baaf121&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7baaf121",
  null
  
)

export default component.exports